import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AbpPostLocationsComponent } from '../../abp-post-locations/abp-post-locations.component';

@Component({
  selector: 'app-submit',
  templateUrl: './submit.component.html',
  styleUrls: ['./submit.component.scss'],
})
export class SubmitComponent implements OnInit, OnChanges, OnDestroy {
  @Input() form: FormGroup;
  @Input() preSelectedLocs: number = 0;
  uploadGroup: FormGroup;
  postDetailsGroup: FormGroup;
  scheduleGroup: FormGroup;
  offerInfoGroup: FormGroup;
  public selectedLocationsCount: number | string;
  private destroy$ = new Subject<void>();

  constructor(
    public dynamicDialogConfig: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    public dialogService: DialogService
  ) {}

  ngOnInit(): void {
    this.uploadGroup = this.form.controls.upload as FormGroup;
    this.postDetailsGroup = this.form.controls.postDetails as FormGroup;
    this.offerInfoGroup = this.form.controls.offerInfo as FormGroup;
    this.scheduleGroup = this.form.controls.schedule as FormGroup;
    this.updateSelectedLocationsCount();
    this.scheduleGroup.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.updateSelectedLocationsCount();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.scheduleGroup && (changes.preSelectedLocs || changes.form)) {
      this.updateSelectedLocationsCount();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateSelectedLocationsCount(): void {
    if (!this.scheduleGroup) {
      console.log('[Submit] updateSelectedLocationsCount: no scheduleGroup');
      return;
    }
    const isSelectedAll = this.scheduleGroup.get('isSelectedAll')?.value;
    const location = this.scheduleGroup.get('location')?.value || [];
    const selectedCount = location.length + this.preSelectedLocs;
    // Only show "All" when the "Select all" checkbox is checked (user chose all locations).
    // Otherwise show the count (e.g. "5 Locations Selected" even if all 5 of a filtered set are selected).
    this.selectedLocationsCount = isSelectedAll ? 'All' : selectedCount;

    console.log('=== SUBMIT LOCATION COUNT ===');
    console.log('isSelectedAll:', isSelectedAll);
    console.log('location (array length):', location.length);
    console.log('preSelectedLocs:', this.preSelectedLocs);
    console.log('selectedCount:', selectedCount);
    console.log('result selectedLocationsCount:', this.selectedLocationsCount);
  }

  openLocations(): void {
    this.dialogService.open(AbpPostLocationsComponent, {
      width: '90%',
      height: '90%',
      data: {
        locations: [...this.scheduleGroup.value.location],
      },
    });
  }

  openLocationsIfNotAll(): void {
    if (this.selectedLocationsCount !== 'All') {
      this.openLocations();
    }
  }

  /** Human-readable labels for filter keys (matches filterCategories in date-locations-form). */
  private readonly filterKeyLabels: Record<string, string> = {
    storeCode: 'Store code',
    businessName: 'Business name',
    city: 'City',
    state: 'State',
    country: 'Country',
    tags: 'Tags',
    labels: 'Labels',
  };

  /** Label for manually selected locations (by filter type(s): Store code, City, State, etc.). */
  get locationsSelectedLabel(): string {
    if (this.selectedLocationsCount === 'All') {
      return 'All Locations Selected';
    }
    const count = this.selectedLocationsCount + ' Locations Selected';
    const filterKeys: string[] = this.scheduleGroup?.get('locationFilterKeys')?.value ?? [];
    if (filterKeys.length === 0) {
      return count;
    }
    const labels = filterKeys
      .map((k) => this.filterKeyLabels[k] ?? k)
      .filter(Boolean);
    if (labels.length === 0) {
      return count;
    }
    const byPhrase = labels.length === 1
      ? labels[0]
      : labels.slice(0, -1).join(', ') + ' and ' + labels[labels.length - 1];
    return `Locations: Manually selected by ${byPhrase} (${count})`;
  }
}
